import { buildColor } from "@tvg/design-system";
import styled, { css } from "styled-components";

const padding = css`
  padding: ${({ theme }) =>
    `${theme.space["space-6"]} ${theme.space["space-6"]} 0 ${theme.space["space-6"]}`};
`;

export const Container = styled.div`
  display: flex;
  height: 500px;
`;

export const FeaturesList = styled.div`
  border-right: 1px solid ${buildColor("grey", "300")};
  min-width: 160px;
  display: flex;
  flex-direction: column;
`;

export const FeaturesDescription = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
`;

export const Description = styled.section`
  ${padding};
  flex-grow: 1;
  overflow: auto;
`;

export const EmptyPage = styled.div`
  flex: 1;
  align-items: center;
  justify-content: center;
  display: flex;
`;

export const TagContainer = styled.div`
  ${padding};
  display: flex;
  align-items: center;
`;

export const Timestamp = styled.p`
  color: ${buildColor("grey", "500")};
`;

export const CTAButtonContainer = styled.div`
  width: 100%;
  padding: ${({ theme }) => theme.space["space-6"]};
  background-color: ${buildColor("white", "900")};
  border-top: 1px solid ${buildColor("grey", "300")};
`;
